<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
@if (hostWidth) {
  <app-loading-skeleton class="block w-full h-[33px]" [viewBox]="'0 0 ' + hostWidth + ' 33'">
    <svg:rect x="0" y="14" rx="4" ry="4" width="80" height="18" />

    @let atAGlanceWidth = hostWidth - 80 - 20;
    @let atAGlanceItemWidth = (atAGlanceWidth - 6) / 4;
    @let atAGlanceItemLabelStart = (atAGlanceItemWidth - 14) / 2;

    <svg:rect [attr.x]="80 + 20 + atAGlanceItemLabelStart" y="2" rx="4" ry="4" width="14" height="14" />
    <svg:rect [attr.x]="80 + 20 + atAGlanceItemWidth + 2 + atAGlanceItemLabelStart" y="2" rx="4" ry="4" width="14" height="14" />
    <svg:rect [attr.x]="80 + 20 + (atAGlanceItemWidth + 2) * 2 + atAGlanceItemLabelStart" y="2" rx="4" ry="4" width="14" height="14" />
    <svg:rect [attr.x]="80 + 20 + (atAGlanceItemWidth + 2) * 3 + atAGlanceItemLabelStart" y="2" rx="4" ry="4" width="14" height="14" />

    <svg:rect [attr.x]="80 + 20" y="19" rx="2" ry="2" [attr.width]="atAGlanceItemWidth" height="10" />
    <svg:rect [attr.x]="80 + 20 + atAGlanceItemWidth + 2" y="19" rx="2" ry="2" [attr.width]="atAGlanceItemWidth" height="10" />
    <svg:rect [attr.x]="80 + 20 + (atAGlanceItemWidth + 2) * 2" y="19" rx="2" ry="2" [attr.width]="atAGlanceItemWidth" height="10" />
    <svg:rect [attr.x]="80 + 20 + (atAGlanceItemWidth + 2) * 3" y="19" rx="2" ry="2" [attr.width]="atAGlanceItemWidth" height="10" />
  </app-loading-skeleton>
}
